import {
  SITE_WIDE_SEARCH,
  SITE_WIDE_SEARCH_SUCCESS,
  SITE_WIDE_SEARCH_FAILURE,
} from "./actionType";

// Action for Site wide Search

const initialState = {
  loading: false,
  siteWideSearchList: [],
};

const SiteSearch = (state = initialState, action) => {
  switch (action.type) {
    case SITE_WIDE_SEARCH:
      return {
        ...state,
        loading: true,
      };
    case SITE_WIDE_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        siteWideSearchList: action.payload,
      };
    case SITE_WIDE_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default SiteSearch;
